module.exports = __webpack_public_path__ + "static/Caley-d9f8363ae9e3f6a6605742ebe2db6d20.png";